<template>
  <div>
    <span
      :class="['badge', 'text-white', getDueDateBadge(dueDate, status)]"
      style="line-height:1.2"
    >{{ dueDate | dateBr }}</span>
  </div>
</template>

<script>

import moment from 'moment'
import Filters from "../../../mixins/Filters";

export default {
  props: {
    dueDate: {},
    status: {}
  },

  methods : {
    getDueDateBadge(date, status) {
      if (this.isOverDue(date) && status == "o") {
        return "badge-danger";
      }
      return "badge-primary";
    },

    isOverDue(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").isBefore(
        moment().subtract(1, "days")
      );
    },
  }
};
</script>
